import React, { memo } from 'react'
import { Link } from 'gatsby'

const Button = ({ data, callback }) => {
  const className = `button-${data?.button_theme}`
  const title = data?.button_title?.text
  const link = data?.button_link

  const element = link?.url ? (
    <Link
      className={`button ${className}`}
      to={link?.url}
      target={link?.target}
    >
      {title}
    </Link>
  ) : (
    <button className={`button ${className}`} type="button" onClick={callback}>
      {title}
    </button>
  )
  return element
}

export default memo(Button)
